import { Search, RefreshCw, PlusCircle, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";

export function AnimateursPage() {
  const animateurs = [
    {
      id: 1,
      name: "Jean Dupont",
      email: "jean.dupont@lesmouettes.com",
      specialite: "Natation",
      experience: "5 ans",
      status: "active",
      planning: "Lun-Mer-Ven",
      avatar: "/api/placeholder/40/40",
    },
    {
      id: 2,
      name: "Claire Bernard",
      email: "claire.bernard@lesmouettes.com",
      specialite: "Voile",
      experience: "8 ans",
      status: "active",
      planning: "Mar-Jeu-Sam",
      avatar: "/api/placeholder/40/40",
    },
    {
      id: 3,
      name: "Marc Rousseau",
      email: "marc.rousseau@lesmouettes.com",
      specialite: "Plongée",
      experience: "12 ans",
      status: "congé",
      planning: "Lun-Jeu-Dim",
      avatar: "/api/placeholder/40/40",
    },
  ];

  return (
    <>
      <header className="flex items-center justify-between border-b border-gray-200 bg-white px-6 py-4">
        <h1 className="text-2xl font-bold text-gray-800">Animateurs</h1>
        <div className="flex items-center space-x-4">
          <div className="relative w-80">
            <Search className="absolute top-1/2 left-3 -translate-y-1/2 transform text-gray-400" size={18} />
            <Input placeholder="Rechercher un animateur..." className="w-full rounded-lg border border-gray-300 py-2 pr-4 pl-10" />
          </div>
          <Button variant="outline" size="icon" className="h-10 w-10">
            <RefreshCw size={18} />
          </Button>
          <Button className="bg-blue-500 text-white hover:bg-blue-600">
            <PlusCircle size={18} className="mr-2" />
            Nouvel Animateur
          </Button>
        </div>
      </header>

      <main className="flex-1 overflow-y-auto p-6">
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {animateurs.map((animateur) => (
            <Card key={animateur.id}>
              <CardHeader className="pb-3">
                <div className="flex items-center space-x-3">
                  <Avatar className="h-12 w-12">
                    <AvatarImage src={animateur.avatar} alt={animateur.name} />
                    <AvatarFallback>
                      {animateur.name
                        .split(" ")
                        .map((n) => n[0])
                        .join("")}
                    </AvatarFallback>
                  </Avatar>
                  <div>
                    <CardTitle className="text-lg">{animateur.name}</CardTitle>
                    <p className="text-sm text-gray-600">{animateur.email}</p>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  <div>
                    <p className="text-sm font-medium text-gray-700">Spécialité</p>
                    <Badge variant="outline" className="mt-1">
                      {animateur.specialite}
                    </Badge>
                  </div>

                  <div>
                    <p className="text-sm font-medium text-gray-700">Expérience</p>
                    <p className="text-sm text-gray-600">{animateur.experience}</p>
                  </div>

                  <div className="flex items-center space-x-2">
                    <Calendar size={14} className="text-gray-400" />
                    <span className="text-sm text-gray-600">{animateur.planning}</span>
                  </div>

                  <div className="flex items-center justify-between pt-2">
                    <Badge variant={animateur.status === "active" ? "default" : "secondary"}>{animateur.status === "active" ? "Actif" : "En congé"}</Badge>
                    <Button variant="outline" size="sm">
                      Planning
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </main>
    </>
  );
}
